
<div class="eau-answer-app-container" #container></div>

<div *ngIf="shouldShowLoadingMsg()">{{'common.loading' | translate}}</div>

<div class="alert alert-error alert-sm" role="alert" *ngIf="shouldShowErrorMsg()">
    <span class="vismaicon vismaicon-filled vismaicon-error" aria-hidden="true"></span>
    {{'answer_app_integration.failed_to_load_tendsigndocs' | translate}}
</div>
